import React, { Fragment }  from 'react';
import {TextField, Box, IconButton, Dialog, DialogTitle, Button, styled, Divider, Tooltip, makeStyles} from "@material-ui/core";
//import { DateRangePicker, LocalizationProvider, StaticDateRangePicker, DateRangePickerDay as MuiDateRangePickerDay } from "@mui/lab";
import {  DateRangePickerDay as MuiDateRangePickerDay } from "@mui/lab";
import {
  StaticDateRangePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers-pro";
import {Switch ,FormControl,FormGroup,FormControlLabel,createStyles} from '@material-ui/core'
import {useSelector} from 'react-redux'
import {isEmpty, isUndefined} from 'lodash'
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { KeyboardDatePicker,DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment-timezone'; 
import { AdapterDateFns, } from '@mui/x-date-pickers/AdapterDateFns';
import {Check, Close} from '@material-ui/icons'
import {isNull} from 'lodash'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const useStyles = makeStyles(theme =>
    createStyles({
      inputs: {
        [theme.breakpoints.down('sm')]: {
          "& input": {
            fontSize: 14,
            minWidth:100
          }
        },
        [theme.breakpoints.down('md')]: {
          "& input": {
            fontSize: 14,
            minWidth:200
          }
        },
        [theme.breakpoints.down('lg')]: {
          "& input": {
            fontSize: 14,
            minWidth:150
          }
        },
      },
      newPadding: {
        "& input": {
          padding: '8px 10px',
        },
        [theme.breakpoints.down('xs')]: {
          "& input": {
            padding: '8px 10px',
          }
        },
        [theme.breakpoints.down('sm')]: {
          "& input": {
            padding: '8px 10px',
          }
        },
        [theme.breakpoints.down('md')]: {
          "& input": {
            padding: '8px 10px',
          }
        },
        [theme.breakpoints.down('lg')]: {
          "& input": {
            padding: '8px 10px',
          }
        },        
      }
      
    })
  );
  const DateRangePickerDay = styled(MuiDateRangePickerDay)(
    ({
      theme,
      isHighlighting,
      isStartOfHighlighting,
      isEndOfHighlighting,
      outsideCurrentMonth,
    }) => ({
      ...(!outsideCurrentMonth &&
        isHighlighting && {
          // borderRadius: 0,
          // backgroundColor: theme.palette.primary.main,
          // color: theme.palette.common.white,
          // '&:hover, &:focus': {
            // backgroundColor: theme.palette.primary.dark,
          // },
        }),
      ...(isStartOfHighlighting && {
        backgroundColor: theme.palette.primary.main,
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
      }),
      ...(isEndOfHighlighting && {
        backgroundColor: theme.palette.primary.main,
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
      }),
    }),
  );
  
function CheckBoxDatum(props) {
    const classes=useStyles()
    const [Value1,setValue1] = React.useState(moment().format("YYYY-MM-DD"))
    const [Value2,setValue2] = React.useState(moment().format("YYYY-MM-DD"))
    const [open, setOpen] = React.useState(false)
     React.useEffect(() => {
        const hideLicenseBanner = () => {
          const targetDiv = Array.from(document.querySelectorAll("div")).find((el) =>
            el.textContent.trim() === "MUI X: Missing license key"
          );
          if (targetDiv) {
            targetDiv.style.display = "none";
          }
        };
    
        // Run once and then check every 500ms in case MUI injects it later
        hideLicenseBanner();
        const interval = setInterval(hideLicenseBanner, 50);
        return () => clearInterval(interval);
      }, []);

    const handleClose = () => {
      setOpen(false);
    };
    const handleOpen = (e) => {
      e.currentTarget.blur()
      setOpen(true)
    }
    const handleChangeDate = (newValue) => {
      console.log(newValue)
      setValue1(moment(newValue[0]).format("YYYY-MM-DD"))
      setValue2(moment(newValue[1]).format("YYYY-MM-DD"))
    }
    const renderWeekPickerDay = (date, dateRangePickerDayProps) => {
      return <DateRangePickerDay {...dateRangePickerDayProps} />;
    };
    const handleSetLast30Days = () => {
      setValue1(moment().subtract(30, 'days').format("YYYY-MM-DD"))
      setValue2(moment().format("YYYY-MM-DD"))
    }
    const handleSetLastMonth = () => {
      setValue1(moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD"))
      setValue2(moment().subtract(1, 'month').endOf('month').format("YYYY-MM-DD"))
    }
    const handleSetLast3Month = () => {
      setValue1(moment().subtract(3, 'month').startOf('month').format("YYYY-MM-DD"))
      setValue2(moment().subtract(1, 'month').endOf('month').format("YYYY-MM-DD"))
    }
    const handleSetThisYear = () => {
      setValue1(moment().startOf('year').format("YYYY-MM-DD"))
      setValue2(moment().endOf('year').format("YYYY-MM-DD"))
    }
    const handleSetLastYear = () => {
      setValue1(moment().subtract(1, 'year').startOf('year').format("YYYY-MM-DD"))
      setValue2(moment().subtract(1, 'year').endOf('year').format("YYYY-MM-DD"))
    }
  const handleSetAllt = () => {

  }
  const handleAddDate = () => {
    props.onChangeMstate(true,{Meta:`${props.Meta} F.O.M`,MetaN:`${props.MetaN} F.O.M`,Value:Value1,Checked:true,Type:"dateH",isSwitch:false},4,
    {Meta:`${props.Meta} T.O.M`,MetaN:`${props.MetaN} T.O.M`,Value:Value2,Checked:true,Type:"dateH",isSwitch:false}
    )
    setOpen(false)
  }


    const ChangeMstate=(e)=>{
        console.log(e.target.checked)
        props.onChangeMstate(e.target.checked,{Meta:props.Meta,MetaN:props.MetaN,Value:-1,Checked:e.target.checked,Type:"Column",isSwitch:true})
    }
   
    React.useEffect(()=>{
      console.log(props.Mstate,"props.Mstate")
      if(!isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))){
        if(!isEmpty(props.Mstate.filter(item=>{return item.MetaN === `${props.MetaN} F.O.M`}))){
      if(isEmpty(props.Mstate.filter(item=>{return item.MetaN === `${props.MetaN} F.O.M`})[0].Value)){
        setValue1(moment().format("YYYY-MM-DD"))
      }else{
        setValue1(props.Mstate.filter(item=>{return item.MetaN === `${props.MetaN} F.O.M`})[0].Value)
      }
    }
    if(!isEmpty(props.Mstate.filter(item=>{return item.MetaN === `${props.MetaN} T.O.M`}))){
      if(isEmpty(props.Mstate.filter(item=>{return item.MetaN === `${props.MetaN} T.O.M`})[0].Value)){
        setValue2(moment().format("YYYY-MM-DD"))
      }else{
        setValue2(props.Mstate.filter(item=>{return item.MetaN === `${props.MetaN} T.O.M`})[0].Value)
      }
      }
    }
    },[JSON.stringify(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))])
    const GetLabel=()=>{
      switch(props.Meta){
          case "Skapad datum": return props.intl.formatMessage({ id: 'Chips.Createddatum' });
          case "Klarmarkerad datum": return props.intl.formatMessage({ id: 'Label.Date.Clear.marked' });
          case "Förfallodatum": return props.intl.formatMessage({ id: 'date.dueDate' });
          case "Ändrad": return props.intl.formatMessage({ id: 'Changed' });
          case "Skapad": return props.intl.formatMessage({ id: 'Created' });
          case "Avtal skapa datum": return props.intl.formatMessage({ id: 'Label.Contract.Createddate' });
          case "Avtal start datum": return props.intl.formatMessage({ id: 'Label.Contract.Startddate' });
          case "Avtal omförhandling datum": return props.intl.formatMessage({ id: 'Label.Contract.Renegotiationdate' });
          case "Avtal löper ut datum": return props.intl.formatMessage({ id: 'Label.Contract.Expiresdate' });
          case "Faktura datum": return props.intl.formatMessage({ id: 'Label.Invoice.date' });
          case "Betalatdatum": return props.intl.formatMessage({ id: 'Table.Payment.date' });
          case "Slut datum": return props.intl.formatMessage({ id: 'Label.EndDate' });
          case "Start": return props.intl.formatMessage({ id: 'Start' });
          case "End": return props.intl.formatMessage({ id: 'Label.End' });
          case "Bokat datum": return props.intl.formatMessage({ id: 'Label.Booking.Time' });
          case "Avbokat datum": return props.intl.formatMessage({ id: 'Label.Cancelation.Time' });
          case "Fakturadatum": return props.intl.formatMessage({ id: 'input.Invoicing.date' });
          case "Slutbetald": return props.intl.formatMessage({ id: 'Invoice.Status.paid' });
          case "Deadline": return props.intl.formatMessage({ id: 'Deadline' });
          case "Order registrering datum": return props.intl.formatMessage({ id: 'Label.Order.Reg.date' });
          case "Order skapad datum": return props.intl.formatMessage({ id: 'Label.Order.Create.date' });
          case "Registrerad": return props.intl.formatMessage({ id: 'Label.Registered' });
          case "Tidstart": return props.intl.formatMessage({ id: 'Label.Time.start' });
          case "TidEnd": return props.intl.formatMessage({ id: 'Label.Time.End' });
          case "Prospekt skapa datum": return props.intl.formatMessage({ id: 'Label.Prospect.Created.date' });
          case "Prospekt start datum": return props.intl.formatMessage({ id: 'Label.Prospect.Start.date' });
          case "Prospekt deadline datum": return props.intl.formatMessage({ id: 'Label.Prospect.Deadline.date' });
          case "Abonnemang startdatum": return props.intl.formatMessage({ id: 'Label.Report.Invoincing.startdate' });
          case "Abonnemang Periodstart": return props.intl.formatMessage({ id: 'Label.Report.Invoincing.Periodstart' });
          case "Abonnemang Periodslut": return props.intl.formatMessage({ id: 'Label.Report.Invoincing.Periodslut' });
          case "Prospekt förlorad datum": return props.intl.formatMessage({ id: 'Label.Report.Prospect.LostDate' });
          default: return props.Meta
      }
  }
    const FromLabel=props.intl.formatMessage({ id: 'From' });
    const ToLabel=props.intl.formatMessage({ id: 'To' });
    return (
        <>
       <Box display="flex" p={0} m={0} mb={1} style={{ width:"100%" }} alignItems="start">
       <Box p={0}>
        <FormControl component="fieldset" fullWidth>
                <FormGroup aria-label="position"  row>
                <FormControlLabel
              value={true}  
              style={{ width:"100%" }}      
              control={
              <Switch color="primary"
              disabled={props.disabled} 
              checked={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?false:true}
              onChange={ChangeMstate}
              size="small"
              />
              }
              label={<></>}
              labelPlacement={"end"}
              />
              </FormGroup>
              
              </FormControl>   
              </Box> 
        <Box p={0} flexGrow={1}>
          <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
            <>
              <KeyboardDatePicker
                fullWidth
                defaultValue=""
                inputVariant="outlined"
                className={`${classes.newPadding} px-1`}
                InputProps={{
                  className: classes.inputs
                }}
                invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                variant="inline"
                format="yyyy-MM-dd"
                size="small"
                cancelLabel={<IntlMessages id="Cancel"/>}
                name={`${props.MetaN} F.O.M`}
                disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
                // onClick={handleOpen}
                // onFocus={handleOpen}
                onChange={(date) => {
                  setValue1(state => (moment(date).format("YYYY-MM-DD")))
                }}
                label={`${GetLabel()} ${FromLabel}:`}
                value={isNull(Value1) ? moment() : Value1 === "Allt"?moment():Value1}
                InputLabelProps={{ shrink: true, style: {whiteSpace: 'nowrap'} }}
                KeyboardButtonProps={{
                  "class": "px-0 m-0 btn btn-sm d-none",
                }}
                />
              </>
            </MuiPickersUtilsProvider>
          </Box> 
          <Box p={0}>  
            <b className="d-flex justify-content-center mx-3" style={{ margin: '0', fontSize: 22, paddingTop: 2 }}>-</b>
          </Box> 
          <Box p={0} flexGrow={1}>
            <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
              <>
                <KeyboardDatePicker
                  fullWidth
                  defaultValue=""
                  className={`${classes.newPadding} px-1`}
                  InputProps={{
                    className: classes.inputs
                  }}
                  invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                  format="yyyy-MM-dd"
                  inputVariant="outlined"
                  variant="inline"
                  size="small"
                  cancelLabel={<IntlMessages id="Cancel"/>}
                  name={`${props.MetaN} T.O.M`}
                  disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
                  // onClick={handleOpen}
                  // onFocus={handleOpen}
                  onChange={(date) => {
                    setValue2(state => (moment(date).format("YYYY-MM-DD")))
                  }}
                  label={`${GetLabel()} ${ToLabel}:`}
                  value={isNull(Value2) ? moment() : Value2 === "Allt"?moment():Value2}
                  InputLabelProps={{ shrink: true,  style: {whiteSpace: 'nowrap'} }}
                  KeyboardButtonProps={{
                    "class": "px-0 m-0 btn btn-sm d-none"
                  }}
                />
              </>
            </MuiPickersUtilsProvider>
          </Box> 
          <Box px={1}  style={{paddingTop: 4}}>  
          <Tooltip title={<IntlMessages id="Choose.Date.Range"/>}>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={handleOpen}
              disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
              size="small"
            >
              <CalendarMonthIcon />
            </IconButton>
          </Tooltip>
        </Box> 
          <Box pr={1} style={{paddingTop: 4}}>  
          <Tooltip title={<IntlMessages id="Add"/>}>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={handleAddDate}
              disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
              size="small"
            >
              <Check />
            </IconButton>
          </Tooltip>
        </Box> 
      </Box>
      <Dialog onClose={handleClose} open={open} maxWidth="unset">
        <div className="d-flex align-items-center justify-content-between w-100">
          <DialogTitle><IntlMessages id="Choose"/> {String(props.Meta).toLowerCase()}</DialogTitle>
          {
            (!isNull(Value1) && !isNull(Value2)) && 
            <DialogTitle>
              {
                Value1==='Allt'?
                <span><IntlMessages id="Label.all.All"/></span>
                :
                <>
                <span>{isNull(Value1) ? 'YYYY-MM-DD' : moment(Value1).format('YYYY-MM-DD')}</span>
                <span className="mx-2"><IntlMessages id="Title.probability.Update2"/></span>
                <span>{isNull(Value2) ? 'YYYY-MM-DD' : moment(Value2).format('YYYY-MM-DD')}</span>
                </>  
              }
              
            </DialogTitle>
          }
          <IconButton onClick={() => setOpen(false)} style={{marginRight: 12, marginLeft:100}}>
            <Close/>
          </IconButton>
        </div>
        <Divider/>
        <Box display="flex">
          <Box>
           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={sv}>
             <StaticDateRangePicker
               displayStaticWrapperAs="desktop"
               startText="Check-in"
               endText="Check-out"
               value={[Value1,Value2]}
               onChange={handleChangeDate}
               renderInput={(startProps, endProps) => (
                 <>
                   <TextField {...startProps} />
                   <TextField {...endProps} />
                 </>
               )}
             />
           </LocalizationProvider>
          </Box>
          <Box display="flex" flexDirection="column" mr={3} pt={2} pl={1}>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLast30Days}><IntlMessages id="Date.Option1"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLastMonth}><IntlMessages id="Date.Option2"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLast3Month}><IntlMessages id="Date.Option3"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetThisYear}><IntlMessages id="Date.Option4"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLastYear}><IntlMessages id="Date.Option5"/></Button>
            {
              parseInt(props.withOutAll) ===1 ?
              <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetAllt}><IntlMessages id="Label.all.All" /></Button>
              :""
            }
          </Box>
        </Box>
        <Divider/>
        <div className="d-flex my-2 mr-2">
          <div className="ml-auto">
            <Button
            variant="contained"
            color="primary"
            className="jr-btn"
            onClick={handleAddDate} 
            ><IntlMessages id="Add"/>
            </Button>
          </div>  
        </div>
        {/* <div className="w-100 d-flex justify-content-end p-2 px-3">
          <Button size="small" color="primary" onClick={handleAddDate} variant="outlined"><IntlMessages id="Add"/></Button>
        </div> */}
      </Dialog>


{/*



            <FormControl component="fieldset" fullWidth>
                <FormGroup aria-label="position"  row>
                <FormControlLabel
              value={true}  
              style={{ width:"100%" }}      
              control={
              <Switch color="primary"
              disabled={props.disabled} 
              checked={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?false:true}
              onChange={ChangeMstate}
              size="small"
              />
              }
              label={<Grid 
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                >
                    <Grid item xs={6}>
            <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
            <Fragment>
            <KeyboardDatePicker
               inputVariant="outlined"
               invalidDateMessage={<IntlMessages id="Date.inValid"/>}
               className={`${classes.newPadding} px-1`}
               label={`${props.Meta} F.O.M:`}
               disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
               size="small"
               name={`${props.MetaN} F.O.M`}
               format="yyyy-MM-dd"
               variant="outlined"
               cancelLabel={<IntlMessages id="Cancel"/>}
               InputProps={{
                className: classes.inputs
              }}
               animateYearScrolling
               value={Value1}
               onChange={(date)=>onChangeHandle1(date)}
               KeyboardButtonProps={{
                "className": "px-0 m-0 btn btn-sm"
               }}
                />   
            </Fragment>
            </MuiPickersUtilsProvider>
        </Grid>
       
          <Grid item xs={6}> 
            <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}> 
            <Fragment>
            <KeyboardDatePicker
               inputVariant="outlined"
               className={`${classes.newPadding} px-1`}
               invalidDateMessage={<IntlMessages id="Date.inValid"/>}
               label={`${props.Meta} T.O.M:`}
               disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
               size="small"
               InputProps={{
                className: classes.inputs
              }}
               name={`${props.MetaN} T.O.M`}
               format="yyyy-MM-dd"
               cancelLabel={<IntlMessages id="Cancel"/>}
               variant="outlined"
               animateYearScrolling
               value={Value2}
               onChange={(date)=>onChangeHandle2(date)}
               KeyboardButtonProps={{
                "className": "px-0 m-0 btn btn-sm"
               }}
                />   
            </Fragment>
            </MuiPickersUtilsProvider>
            </Grid>
    </Grid>}
              labelPlacement={"end"}
              />
              </FormGroup>
              
           </FormControl>    
           */}
        </>
    );
}

export default injectIntl(CheckBoxDatum);